<ng-content select="[prefix]"></ng-content>
<strong class="label" (click)="labelClick.emit($event)">{{ label$ | ngrxPush }}</strong>
<ng-content select="[suffix]"></ng-content>
